module.exports = __webpack_public_path__ + "img/result-rate.789a8790.png";